// extracted by mini-css-extract-plugin
export var errorIcon = "_mg-1";
export var nameLogo = "_mg-0";